import {useFormState} from "./formContext";

export const useIsFieldRequired = formKey => {
    const {schema} = useFormState()

    return schema
        && schema.fields[formKey]
        && "required" === schema.fields[formKey].spec.presence
}